import { OnDestroy, Inject, PLATFORM_ID } from "@angular/core";
import { Title, Meta, platformBrowser } from "@angular/platform-browser";

import { LinkService } from "../../service/link.service";
import { isPlatformBrowser } from "@angular/common";

export class seoManagement implements OnDestroy {
  URL = "https://www.easyschools.org/";
  constructor(
    public titleService: Title,
    public metaService: Meta,
    public isBrowser: Boolean,
    public currentLangId: string,
    public link: LinkService
  ) {}
  /**
   *
   * @param Title title tag
   * @param description  description tag content
   * @param img  img for share
   * @param url  url for share
   */
  setSeoTags(Title, description, img, url, currentPage?): void {
    this.ngOnDestroy();
    if (!img) {
      img = "https://www.newfurniture-eg.com/assets/logo.png";
    }
    this.titleService.setTitle(Title);
    this.metaService.addTags([
      {
        name: "description",
        content: description
      },
      {
        itemprop: "description",
        name: "og:description",
        content: description
      },
      {
        itemprop: "description",
        content: description
      },
      {
        name: "twitter:description",
        content: description
      },
      {
        name: "og:title",
        content: Title
      },
      {
        name: "og:type",
        content: "article"
      },
      {
        name: "og:url",
        content: url
      },
      {
        name: "og:image",
        content: img
      },
      {
        name: "twitter:card",
        content: "summary"
      },
      {
        name: "twitter:title",
        content: Title
      },
      {
        name: "twitter:image",
        content: img
      },
      {
        itemprop: "name",
        content: Title
      },
      {
        itemprop: "image",
        content: img
      }
    ]);

    this.addLinkTagtoPage(currentPage, url);
  }

  addLinkTagtoPage(currentPage, url): void {
    const alternativeLng = this.currentLangId === "en" ? ".com/ar/" : ".com/",
      altLang = this.currentLangId === "ar" ? "en" : "ar";

    const locle = this.currentLangId == "en" ? "en_US" : "ar_AR",
      alte = this.currentLangId != "en" ? "en_US" : "ar_AR";
    this.link.removeTag('rel="canonical"');
    this.link.removeTag('rel="alternate"');

    this.link.addTag({
      rel: "canonical",
      href: url,
      hreflang: this.currentLangId + "-eg"
    });
    this.link.addTag({
      rel: "alternate",
      href:
        this.currentLangId === "en"
          ? url.replace(`.com/`, `${alternativeLng}`)
          : url.replace(`.com/ar/`, `${alternativeLng}`),
      hreflang: altLang + "-eg"
    });

    this.metaService.addTag({
      property: "og:locale",
      content: `${locle}`
    });
    this.metaService.addTag({
      property: "og:locale:alternate",
      content: `${alte}`
    });
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      this.metaService.removeTag(" name ='twitter:description'");
      this.metaService.removeTag(" name ='og:description'");
      this.metaService.removeTag(" name ='description'");
      this.metaService.removeTag("itemprop='description'");
      this.metaService.removeTag(" name = 'og:title' ");
      this.metaService.removeTag(" name ='og:url'");
      this.metaService.removeTag(" name ='og:image'");
      this.metaService.removeTag(" name ='og:locale:alternate'");
      this.metaService.removeTag(" name ='og:locale:alternate'");

      this.metaService.removeTag(" name ='twitter:title'");
      this.metaService.removeTag(" name ='twitter:image'");
      this.metaService.removeTag(" itemprop ='name'");
      this.metaService.removeTag(" itemprop ='image'");
    }
  }
}
